// src/components/DonateSuccessPage.jsx

import React, { useState, useEffect } from "react";
import { useStripe } from "@stripe/react-stripe-js";

const DonateSuccess = () => {
  const stripe = useStripe();
  const [title, setTitle] = useState("Loading");
  const [message, setMessage] = useState("Verifying your donation...");

  useEffect(() => {
    if (!stripe) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    // Get the client secret from the URL query string
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      setMessage(
        "Error: Could not find payment details. Please get in touch via the contact page."
      );
      return;
    }

    // Retrieve the PaymentIntent
    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      // --- INSPECT THE RESULT AND DISPLAY A MESSAGE ---
      switch (paymentIntent.status) {
        case "succeeded":
          setTitle("Success! Thank you!");
          setMessage("Your donation has been received. Thank you!");
          localStorage.setItem("nwd_donated", "1");
          break;
        case "processing":
          setTitle("Your donation is processing.");
          setMessage(" We'll update you when it's complete.");
          break;
        case "requires_payment_method":
          setTitle("Donation failed.");
          setMessage("Please try another payment method.");
          break;
        default:
          setMessage(
            "Something went wrong. Please contact support via the contact page."
          );
          break;
      }

      // --- CLEAN THE URL ---
      // This is the logic from the previous answer.
      // It removes the sensitive parameters from the address bar.
      const url = new URL(window.location);
      url.searchParams.delete("payment_intent");
      url.searchParams.delete("payment_intent_client_secret");
      url.searchParams.delete("redirect_status");
      window.history.replaceState({}, document.title, url);
    });
  }, [stripe]); // This effect runs when the 'stripe' object is available.

  return (
    <div className="donation-tile" style={{ textAlign: "center" }}>
      <div>
        <strong>{title}</strong>
      </div>
      <p>{message}</p>
      {title.includes("Thank you") && (
        <>
          <p style={{ fontSize: "0.85rem", color: "#004a22", marginTop: "12px", opacity: 0.8 }}>
            You're part of what makes this possible for everyone else.
          </p>
          <a
            href="/today"
            style={{ display: "inline-block", marginTop: "12px", color: "#004a22", fontWeight: "600" }}
          >
            Return to your journal
          </a>
        </>
      )}
    </div>
  );
};

export default DonateSuccess;
